// metaPixel.js — helper para Meta Pixel client-side (14-jul-2026)
//
// Uso:
//   1) En App.jsx root: importar initMetaPixel() y llamarlo una vez al mount
//   2) En cada cambio de ruta: trackPageView() (automático con react-router listener)
//   3) En eventos custom: trackEvent('Lead'), trackEvent('CompleteRegistration'), etc.
//
// Pixel ID: 2264756617673237 (dataset "Limpack Web", creado 14-jul-2026)
// El ID también está en app_config.META_PIXEL_ID por si queremos leerlo dinámicamente.

const PIXEL_ID = '2264756617673237'

let initialized = false

/** Carga el script fbevents.js si todavía no se cargó, y hace fbq('init', PIXEL_ID). */
export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (initialized) return
  initialized = true

  // Snippet estándar de Meta Pixel adaptado a módulo ES
  ;(function (f, b, e, v) {
    if (f.fbq) return
    const n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

/** Trackea un PageView (llamar en cada cambio de ruta). */
export function trackPageView() {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

/**
 * Trackea un evento estándar de Meta. Ejemplos:
 *   trackEvent('Lead')                            // signup completado
 *   trackEvent('CompleteRegistration')            // password creada, activación completa
 *   trackEvent('InitiateCheckout', { value: 1090, currency: 'UYU' })
 *   trackEvent('Purchase', { value: 1090, currency: 'UYU' })
 *   trackEvent('AddToCart', { content_ids: ['SKU123'], value: 250, currency: 'UYU' })
 * Ver lista completa: https://developers.facebook.com/docs/meta-pixel/reference
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', eventName, params)
}

/** Trackea un evento custom (no estándar de Meta). */
export function trackCustomEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('trackCustom', eventName, params)
}
